import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RequestAgreementResponse } from "@/types";
import { POST_CREATE_AGREEMENTS } from "./routes";

export type CreateAgreementRequestDTO = {
  name: string;
  phone: string;
  commission?: string;
};

async function createAgreement(
  request: CreateAgreementRequestDTO
): Promise<RequestAgreementResponse> {
  const response = await httpRequest.post(POST_CREATE_AGREEMENTS, request);
  return response.data;
}

export function useCreateAgreementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAgreement,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agreements"] });
    },
  });
}
